import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData } from './utils';
var ColumnTypes;
(function (ColumnTypes) {
    ColumnTypes[ColumnTypes["Stock"] = 1] = "Stock";
    ColumnTypes[ColumnTypes["Average"] = 2] = "Average";
    ColumnTypes[ColumnTypes["Current"] = 4] = "Current";
    ColumnTypes[ColumnTypes["About"] = 8] = "About";
    ColumnTypes[ColumnTypes["All"] = 15] = "All";
})(ColumnTypes || (ColumnTypes = {}));
let DemoShowHideColumns = class DemoShowHideColumns extends LitElement {
    constructor() {
        super(...arguments);
        this.data = getData();
        this.toggleColumns = false;
        this.selectedColumns = ColumnTypes.All;
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column>Stock</cds-grid-column>
        ${this.checked(ColumnTypes.Average) ? html `<cds-grid-column>Average</cds-grid-column>` : ''}
        <cds-grid-column ?hidden=${!this.checked(ColumnTypes.Current)}>Current</cds-grid-column>
        <cds-grid-column ?hidden=${!this.checked(ColumnTypes.About)}>About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            ${this.checked(ColumnTypes.Average) ? html `<cds-grid-cell>$${entry.average}</cds-grid-cell>` : ''}
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer>
          <cds-inline-button id="toggle-columns" @click=${() => this.toggleColumns = true} aria-label="filter column">
            <cds-icon shape="view-columns"></cds-icon>
          </cds-inline-button>
          <cds-dropdown ?hidden=${!this.toggleColumns} @hiddenChange=${() => this.toggleColumns = false} anchor="#toggle-columns" position="top">
            <cds-checkbox-group layout="vertical">
              <cds-checkbox>
                <label>Average</label>
                <input type="checkbox" value="${ColumnTypes.Average}" @click=${this.selectColumns} .checked=${this.checked(ColumnTypes.Average)} />
              </cds-checkbox>      
              <cds-checkbox>
                <label>Current</label>
                <input type="checkbox" value="${ColumnTypes.Current}" @click=${this.selectColumns} .checked=${this.checked(ColumnTypes.Current)} />
              </cds-checkbox>
              <cds-checkbox>
                <label>About</label>
                <input type="checkbox" value="${ColumnTypes.About}" @click=${this.selectColumns} .checked=${this.checked(ColumnTypes.About)} />
              </cds-checkbox>
            </cds-checkbox-group>
            <cds-button action="flat" @click=${this.selectAll} ?disabled=${this.checked(ColumnTypes.All)}>Select All</cds-button>
          </cds-dropdown>
        </cds-grid-footer>
      </cds-grid>
    `;
    }
    selectColumns() {
        this.selectedColumns = Array.from(this.querySelectorAll('input[type="checkbox"]'))
            .filter(c => c.checked).map(c => parseInt(c.value)).reduce((p, n) => p + n, 0);
    }
    selectAll() {
        this.selectedColumns = this.checked(ColumnTypes.All) ? 0 : ColumnTypes.All;
    }
    checked(value) {
        return value === (this.selectedColumns & value);
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoShowHideColumns.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoShowHideColumns.prototype, "toggleColumns", void 0);
__decorate([
    internalProperty()
], DemoShowHideColumns.prototype, "selectedColumns", void 0);
DemoShowHideColumns = __decorate([
    customElement('demo-show-hide-columns')
], DemoShowHideColumns);
export { DemoShowHideColumns };
//# sourceMappingURL=demo.column-show-hide.js.map